module.exports = __webpack_public_path__ + "img/ic_tune.8a084911.svg";